import { Component } from "react";

import "./Mainpage.css";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";
import mainBanner from "./resources/mainPage/heading.png";
import watsappCta from "./resources/mainPage/CTAWHATSAPP.png";
import notificaionCta from "./resources/mainPage/pnCTA.png";
import bannerCta from "./resources/mainPage/bannerCTA.png";

class Mainpage extends Component {
  constructor() {
    super();
    this.state = {
      posterType: "",
      Color: "",
      appName: "",
      courseName: "",

      benefit: "",
    };
  }

  render() {
    return (
      <>
        <div className="mainPage">
          <img src={mainBanner} id="mainBanner" />
          <div className="mainCtas">
            <Link
              to={{
                pathname: "/details",
                state: { posterType: "watsapp" },
              }}
            >
              <img
                src={watsappCta}
                // onClick={() => {
                //   this.setState({ posterType: "wastsapp" });
                // }}
              />
            </Link>

            <Link
              to={{
                pathname: "/details",
                state: { posterType: "notification" },
              }}
            >
              <img
                src={notificaionCta}
                onClick={() => {
                  this.setState({ posterType: "notification" });
                }}
              />
            </Link>

            <Link
              to={{
                pathname: "/details",
                state: { posterType: "banner" },
              }}
            >
              <img
                src={bannerCta}
                id="app-bottom-cta"
                onClick={() => {
                  this.setState({ posterType: "banner" });
                }}
              />
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default Mainpage;
